<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">Administración de coordinadores</div>
            </div>
          </div>
          <div class="buttonGenerar">
            <br />
            <b-button
              variant="primary"
              @click="abrirDetalleEmpty()"
              v-if="$localStorageService.can('AC_01_coordinadores_crear')"
            >
              Asignar coordinador
            </b-button>
          </div>

          <div class="flxDivs">
            <div class="div90">
              <b-skeleton-table
                :rows="5"
                :columns="12"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="arrayCoordinadores.length != 0">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Buscar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Limpiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-table
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  responsive
                  striped
                  hover
                  :items="arrayCoordinadores"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  v-if="
                    arrayCoordinadores.length != 0 && cargandoTabla == false
                  "
                  thead-tr-class="columnas"
                >
                  <template v-slot:cell(registroActivo)="row">
                    <span v-if="row.item.registroActivo == true">
                      <b-badge variant="success"
                        ><b-icon icon="check-square" font-scale="1.5"></b-icon
                      ></b-badge>
                    </span>
                    <span v-else>
                      <b-badge variant="warning"
                        ><b-icon icon="x-square" font-scale="1.5"></b-icon
                      ></b-badge>
                    </span>
                  </template>

                  <template #cell(Detalle)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalle(row.item)"
                      v-if="
                        $localStorageService.can('AC_01_coordindores_detalle')
                      "
                    >
                      <em class="fa fa-eye"></em>
                    </b-button>
                  </template>

                  <b-badge variant="warning">Warning</b-badge>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  aria-controls="my-table1"
                ></b-pagination>
                <br />
                <br />
              </span>
              <strong
                v-if="arrayCoordinadores.length == 0 && cargandoTabla == false"
                >Sin registros</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-detalle" hide-footer>
      <template #modal-title>Detalle</template>
      <div class="d-block text-left">
        <div class="flexDiv" v-if="info.nombreCompleto != null">
          <p class="item80">
            <strong>Empleado: </strong>{{ info.nombreCompleto }}
          </p>

          <b-button
            title="Eliminar registro"
            variant="danger"
            size="sm"
            class="item20"
            @click="(info.nombreCompleto = null), (info.idEmpleado = null)"
          >
            <b-icon icon="trash-fill"></b-icon>
          </b-button>
        </div>

        <b-form-group label="Empleado" class="mginTop10" v-else>
          <span class="inputIconDiv">
            <v-select
              style="width: 100%"
              label="nombre"
              :filterable="false"
              :options="colaboradores"
              @search="getColaboradores"
              :reduce="(colaborador) => colaborador.id"
              v-model="info.idEmpleado"
              placeholder=""
            >
              <template slot="no-options">Sin datos</template>
            </v-select>

            <b-button variant="primary" disabled v-if="loadingColaboradores">
              <b-spinner small></b-spinner>
            </b-button>
          </span>
        </b-form-group>
        <br />

        <b-form-group label="Puesto *" label-align="left" id="fieldset-2">
          <b-form-select
            v-model="info.tipoCoordinador"
            :options="puestos"
          ></b-form-select>
        </b-form-group>
        <br />

        <b-form-group label="Clínica *" label-align="left" id="fieldset-3">
          <b-form-select
            v-model="info.idClinica"
            :options="clinicas"
          ></b-form-select>
        </b-form-group>
        <br />

        <b-form-checkbox
          switch
          size="sm"
          v-model="info.registroActivo"
          v-if="info.idClinicaCoordinador != null"
          >Activar / Inactivar</b-form-checkbox
        >
      </div>

      <br />
      <br />

      <div class="text-center">
        <b-button
          variant="primary"
          :disabled="info.idEmpleado == null || info.tipoCoordinador == null"
          @click="guardar(info)"
          style="width: 100%"
          >Guardar</b-button
        >
      </div>

      <b-button class="mt-3" block @click="$bvModal.hide('modal-detalle')"
        >Cerrar</b-button
      >
    </b-modal>
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";
//import miniToastr from "mini-toastr"; //ES6

export default {
  name: "admCoordinadores",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      cargandoTabla: false,
      arrayCoordinadores: [],
      fields: [
        { key: "idClinicaCoordinador", label: "No.", sortable: true },
        { key: "tipoCoordinadorNombre", label: "Puesto", sortable: true },
        { key: "clinicaNombre", label: "Cínica", sortable: true },
        { key: "nombreCompleto", label: "Nombre", sortable: true },
        { key: "celular", label: "Celular", sortable: true },
        { key: "correo", label: "Correo", sortable: true },
        { key: "registroActivo", label: "Activo / Inactivo", sortable: true },
        { key: "Detalle", label: "Detalle" },
      ],
      info: {
        celular: null,
        correo: null,
        idClinicaCoordinador: null,
        idClinica: null,
        clinicaNombre: null,
        idEmpleado: null,
        nombreCompleto: null,
        tipoCoordinador: null,
        tipoCoordinadorNombre: null,
        registroActivo: null,
        Detalle: null,
      },
      currentPage: 1,
      perPage: 15,
      totalRows: 1,
      loadingColaboradores: false,
      colaboradores: [],
      puestos: [],
      clinicas: [],
      filterOn: [],
      filter: null,
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerCoordinadores();
    this.getPuestos();
    this.getClinicas();
  },
  methods: {
    getClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((response) => {
          if (response.status === 200) {
            this.clinicas = response.data.data
              .filter(function (item) {
                return item.idClinica != 0;
              })
              .map((it) => {
                return {
                  value: it.idClinica,
                  text: it.strNombre,
                };
              });
            this.clinicas.push({ value: null, text: "-" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getPuestos() {
      this.$http
        .get(this.$api + "saldo/puestos/obtener", {})
        .then((response) => {
          if (response.status === 200) {
            if (Array.isArray(response.data.data) == true) {
              this.puestos = response.data.data.map((it) => {
                return {
                  value: it.idTipoCoordinador,
                  text: it.descripcion,
                };
              });
              this.puestos.push({ value: null, text: "No asignado" });
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getColaboradores(searchTerm) {
      if (searchTerm === "") {
        this.loadingColaboradores = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingColaboradores = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api + "saldo/obtenerDatosEmpleado?nombreEmpleado=" + inputTxt,
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.colaboradores = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingColaboradores = false));
      }
    },
    guardar(datos) {
      datos.idUsuario = this.$localStorageService.getIdUsuario();
      var apiUrl = "guardar";
      if (datos.idNivel != null) {
        apiUrl = "actualizar";
      }

      // API


      this.$swal.fire({
        title: "¿Estás seguro de " + apiUrl + " el registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.loading = true;
          this.$http
            .post(this.$api + "saldo/coordinadores/guardar", datos)
            .then(() => {
              this.obtenerCoordinadores();
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: error,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        },
      });
      //API

      this.$bvModal.hide("modal-detalle");
    },
    abrirDetalle(datos) {
      this.$bvModal.show("modal-detalle");
      this.info = datos;
    },
    abrirDetalleEmpty() {
      this.info.celular = null;
      this.info.correo = null;
      this.info.idClinica = null;
      this.info.idClinicaCoordinador = null;
      this.info.idEmpleado = null;
      this.info.nombreCompleto = null;
      this.info.tipoCoordinador = null;
      this.info.tipoCoordinadorNombre = null;
      this.info.registroActivo = null;

      this.$bvModal.show("modal-detalle");
    },
    obtenerCoordinadores() {
      this.cargandoTabla = true;
      this.$http
        .get(this.$api + "saldo/coordinadores/obtener")
        .then((response) => {
          this.cargandoTabla = false;
          if (response.status === 200) {
            if (Array.isArray(response.data.data) == true) {
              this.arrayCoordinadores = response.data.data;
              this.totalRows = this.arrayCoordinadores.length;

              this.arrayCoordinadores.forEach((element) => {
                element.Detalle = null;
              });
            }
          }
        })
        .catch((error) => {
          this.cargandoTabla = false;
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div90 {
  width: 95%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.buttonGenerar {
  margin-top: 20px;
  margin-right: 10px;
  display: flex;
  justify-content: flex-end;
}

.flexDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  text-align: left;
}

.item80 {
  width: 80%;
}

.item20 {
  width: 20%;
}
</style>
